<template>
<div>

<div class="box box-primary">
  <div class="box-header">         
  </div>  
  <!----> 

  <section class="content1">
    <div class="form-group">
      <div class="row">
        <div class="col-md-3">
          <v-select :options="branches" label="name" name="branch" v-on:input="loadBranchData()" placeholder="Select" v-model="branch"></v-select>
        </div>
        <div class="col-md-3">
          <v-select :options="branchLedgers" label="name" name="ledger" v-on:input="changeFilter()" placeholder="Select" v-model="filter.branchLedger"></v-select>
        </div>
        <div class="col-md-2">
            <select v-model="filter.voucherType" @change="changeFilter()" name="voucher" placeholder="Voucher Type" class="form-control" >
                <option selected value="">Select Voucher</option>
                <option value="payment">Payment</option>
                <option value="receipt">Receipt</option>
                <option value="journal">Journal</option>
                <option value="contra">Contra</option>
            </select>
        </div>
        <div class="col-md-2">
            <input v-model="filter.startDate" type="date" @change="changeFilter()" name="startdate" class="form-control"  />
        </div>
        <div class="col-md-2">
            <input v-model="filter.endDate" type="date" @change="changeFilter()" name="enddate" class="form-control" />
        </div>
        <br>
      </div>
    </div>
  </section>         
</div>





<div class="box box-primary">
        <div class="box-header with-border"> 
        <h3 class="box-title">Ledgers</h3>
            <div class="box-tools pull-right">
              <button @click="print()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
        </div>  
        <!----> 
        <section class="content" id="print">
            <div class="row"> 
                <div v-if="filter.branchLedger" class="col-md-12 bg-green">
                    <center><strong>{{filter.branchLedger.name}}</strong></center>
                </div>
                <div class="col-md-12" style="background-color: #FFFFD9;">                  
                    <div class="row" style="border:solid 1px black;">
                        <div class="col-sm-1"><strong>SN</strong></div>
                        <div class="col-sm-1"><strong>Date</strong></div>
                        <div class="col-sm-1"><strong>Member</strong></div>
                        <div class="col-sm-1"><strong>Loan ID</strong></div>
                        <div class="col-sm-1"><strong>VoucherNo</strong></div>
                        <div class="col-sm-1"><strong>Type</strong></div>
                        <div class="col-sm-2"><strong>Narration</strong></div>
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col-sm-6"><strong>Particular</strong></div>
                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col-sm-12"><strong><center>Amount</center></strong></div>
                                        <div class="col-sm-6"><strong>Dr</strong></div>
                                        <div class="col-sm-6"><b>Cr</b></div>
                                    </div>
                                </div>                            
                            </div>
                        </div>
                    </div>
                    <div class="row" v-for="(row, index) in vouchers" :key="index" style="border:solid 1px black;">
                        <div class="col-sm-1">{{index+1}}</div>
                        <div class="col-sm-1">{{row.date}}</div>
                        <div class="col-sm-1"><span v-if="row.member">{{row.member.name}}</span></div>
                        <div class="col-sm-1"><span v-if="row.disbursement"><i v-if="row.disbursement.member_loan_plan">{{row.disbursement.member_loan_plan.applicationNo}}</i></span><span v-if="row.sattlement"><i v-if="row.sattlement.member_loan_plan">{{row.sattlement.member_loan_plan.applicationNo}}</i></span></div>
                        <div class="col-sm-1">{{row.voucherNo}}</div>
                        <div class="col-sm-1">{{row.voucherType}}</div>
                        <div class="col-sm-2">{{row.narration}}</div>
                        <div class="col-sm-4" style="border:solid 1px black;">
                            <div class="row" v-for="(drLg, index1) in row.dr_ledger" :key="'dr' + index1">
                                <div class="col-sm-6">{{drLg.ledger.name}}</div>
                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col-sm-6">{{drLg.amt}}</div>
                                        <div class="col-sm-6"></div>
                                    </div>
                                </div>                            
                            </div>
                            <div class="row" v-for="(crLg, index2) in row.cr_ledger" :key="'cr' + index2">
                                <div class="col-sm-6">{{crLg.ledger.name}}</div>
                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col-sm-6"></div>
                                        <div class="col-sm-6">{{crLg.amt}}</div>
                                    </div>
                                </div>                            
                            </div>
                        </div>
                    </div>
                    <div class="row" style="border:solid 1px black;">
                        <div class="col-sm-7"></div>
                        <div class="col-sm-5">
                            <div class="row">
                                <div class="col-sm-6"><strong>Total Amount</strong></div>
                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col-sm-6"><strong>{{drTotalAmt}}</strong></div>
                                        <div class="col-sm-6"><b>{{crTotalAmt}}</b></div>
                                    </div>
                                </div>                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <div class="box-footer clearfix" v-if="pagination.current_page > 0">
                  <ul class="pagination pagination-sm no-margin pull-right">
                    <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                    <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                    <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li>
                    <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                    <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                    <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                    <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 7)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                    <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                    <li><a href="#">...</a></li>
                    
                    <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                    <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>



                    <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                    <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
                  </ul>
                </div>
        </section>
    </div>



    <!-- The modal -->
    <div class="modal fade" id="showVoucharModal" tabindex="-1" role="dialog" aria-labelledby="modalLabelSmall" aria-hidden="true">
      <div class="modal-dialog modal-md">
        <div class="modal-content">

          <div class="modal-header label-danger">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="modalLabelSmall">Voucher</h4>
          </div>

          <div class="modal-body">
            <div class="row label-primary">
              <div class="col-md-4"><strong>Date:</strong> {{voucher.date}}</div>
              <div class="col-md-4"><strong>Voucher:</strong> {{voucher.voucherNo}}</div>
              <div class="col-md-4"><strong>Voucher Type:</strong> {{voucher.voucherType}}</div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-6">
                <div class="label-default"><strong>DR Ledger</strong></div><hr>
                <table class="table ">
                  <tr v-for="(dledger, index) in voucher.dr_ledger" :key="index">
                    <td>{{dledger.ledger.name}}</td>
                    <td class="pull-right">{{dledger.amt}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <th class="pull-right"><strong>Dr:{{ voucher_sum(voucher.dr_ledger) }}</strong></th>
                  </tr>
                </table>
              </div>
              <div class="col-md-6">
                <div class="label-default"><strong>CR Ledger</strong></div><hr>
                <table class="table ">
                  <tr v-for="(cledger, index) in voucher.cr_ledger" :key="index">
                    <td>{{cledger.ledger.name}}</td>
                    <td class="pull-right">{{cledger.amt}} </td>
                  </tr>
                  <tr>
                    <td></td>
                    <th class="pull-right"><strong>Cr:{{ voucher_sum(voucher.cr_ledger) }}</strong></th>
                  </tr>
                </table>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-12"><strong>Narration:</strong> {{voucher.narration}}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
</div>
</template>

<script>
var _ = require('lodash')
export default {
  name: 'Voucher',
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 1000,
      editMode: false,
      branches: [],
      branchLedgers: [],
      vouchers: [],
      voucher: {},
      filter: {
        voucherType: '',
        startDate: new Date().toISOString().slice(0, 10),
        endDate: new Date().toISOString().slice(0, 10),
        branchLedger: {id: ''}
      },
      form: new Form({
        id: '',
        voucherNo: '',
        date: '',
        voucherType: '',
        dr_ledger_id: '',
        cr_ledger_id: '',
        amt: '',
        status: ''
      }),
      drledgers: [],
      crledgers: [],
      holdVoucher: {},
      holdVouchers: [],
      branch: {},
      branchLedger: {},
      amt: Number,
      total: 0,
      ledgerItems: [],
      drTotalAmt: 0,
      crTotalAmt: 0,
      balance: 0,
      totalBalanceAmt: 0,
      balanceType: '',
      drTotal: 0,
      crTotal: 0
    }
  },
  methods: {
    totalAmt (amt, type) {
      if (type === 'dr') {
        this.drTotal += parseFloat(amt)
      }
      if (type === 'cr') {
        this.crTotal += parseFloat(amt)
      }
    },
    showVoucher (row) {
      var voucherId = row.voucherId
      this.voucher = _.find(this.vouchers, function (o) { return o.id === voucherId })
    },
    voucher_sum (voucher) {
      return _.sumBy(voucher, function (o) { return +o.amt })
    },
    print () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('print').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html>
                              <html>
                                  <head>
                                      ${stylesHtml}
                                  </head>
                                  <body>
                                      ${prtHtml}
                                  </body>
                              </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    },
    changeFilter (page = null, pg = null) {
      this.drTotal = 0
      this.crTotal = 0
      this.crTotalAmt = 0
      this.drTotalAmt = 0
      this.totalBalanceAmt = 0
      this.balance = 0
      this.balanceType = ''
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'voucher'
      }
      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (this.filter.voucherType) {
        pageUrl += `&voucherType=${this.filter.voucherType}`
      }
      pageUrl += `&branch_id=${this.branch.id}&branch_ledger_id=${this.filter.branchLedger.id}&startDate=${this.filter.startDate}&endDate=${this.filter.endDate}`
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.vouchers = data.data.data
          this.drTotalAmt = data.drTotalAmt
          this.crTotalAmt = data.crTotalAmt
          this.ledgerItems = []
        }).catch(function (error) { console.log(error) })
      // this.$axios
      //   .get('voucher?all=all&voucherType=' + this.filter.voucherType + '&branch_id=' + this.branch.id + '&branch_ledger_id=' + this.filter.branchLedger.id + '&startDate=' + this.filter.startDate + '&endDate=' + this.filter.endDate, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
      //   .then((data) => {
      //     this.vouchers = data.data
      //     this.drTotalAmt = data.drTotalAmt
      //     this.crTotalAmt = data.crTotalAmt
      //     this.ledgerItems = []
      //   }).catch(function (error) { console.log(error) })
    },
    loadBranchData () {
      this.$axios
        .get('branchledger?all=all&status=active&branch_id=' + this.branch.id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.branchLedgers = data.data
          $.each(this.branchLedgers, function (key, value) {
            this.branchLedgers[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
      this.changeFilter()
    },
    loadData () {
      this.$axios
        .get('branch?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        }).catch(function (error) { console.log(error) })
    }
  },

  created () {
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>

<style>
.row {
    padding: 2px;
}
</style>



// WEBPACK FOOTER //
// Daybook.vue?2bb879ce